import RechargeRelatedAPI from "./RechargeRelatedAPI";
import WithdrawalRelatedAPI from "./WithdrawalRelatedAPI";
import AssetSearch from "./AssetSearch";
// import { merchantStroe } from "@/stores";
import {
  APP_COIN_ASSET,
  APP_DEPOSIT__RECORD,
  APP_DEPOSIT__RECORD_LIST,
  APP_ORDERRECORD,
  APP_WITHDRAW__RECORD,
  APP_WITHDRAW__RECORD_LIST,
  APP_WITHDRAW__TO_CWALLET,
  APP_WITHDRAW__TO_NETWORK,
  CREATE_APP_AORDER_EPOSIT_ADDRESS,
  CREATE_APP_DEPOSIT__ADDRESS,
} from "@/config";
import { useAuthContext } from "@/auth/useAuthContext";

export default function Index() {
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  let APP_COIN_ASSET_ = check ? APP_COIN_ASSET : "***";

  let CREATE_APP_AORDER_EPOSIT_ADDRESS_ = check
    ? CREATE_APP_AORDER_EPOSIT_ADDRESS
    : "***";
  let APP_WITHDRAW__RECORD_ = check ? APP_WITHDRAW__RECORD : "***";
  let APP_ORDERRECORD_ = check ? APP_ORDERRECORD : "***";
  let CREATE_APP_DEPOSIT__ADDRESS_ = check
    ? CREATE_APP_DEPOSIT__ADDRESS
    : "***";
  let APP_DEPOSIT__RECORD_ = check ? APP_DEPOSIT__RECORD : "***";
  let APP_DEPOSIT__RECORD_LIST_ = check ? APP_DEPOSIT__RECORD_LIST : "***";
  let APP_WITHDRAW__RECORD_LIST_ = check ? APP_WITHDRAW__RECORD_LIST : "***";
  let APP_WITHDRAW__TO_NETWORK_ = check ? APP_WITHDRAW__TO_NETWORK : "***";
  let APP_WITHDRAW__TO_CWALLET_ = check ? APP_WITHDRAW__TO_CWALLET : "***";

  return (
    <>
      <AssetSearch url={APP_COIN_ASSET_} />
      <RechargeRelatedAPI
        url={CREATE_APP_AORDER_EPOSIT_ADDRESS_}
        url_={APP_ORDERRECORD_}
        url_1={CREATE_APP_DEPOSIT__ADDRESS_}
        url_2={APP_DEPOSIT__RECORD_}
        url_3={APP_DEPOSIT__RECORD_LIST_}
      />
      <WithdrawalRelatedAPI
        url={APP_WITHDRAW__RECORD_}
        url_={APP_WITHDRAW__RECORD_LIST_}
        url_1={APP_WITHDRAW__TO_NETWORK_}
        url_2={APP_WITHDRAW__TO_CWALLET_}
      />
    </>
  );
}
